<template>
  <div class="goods-info">
    <!-- 搜索 -->
    <div class="search">
      <div class="search-left">
        <span class="title">货主名称：</span>
        <el-select v-model="customerId" placeholder="请选择货主" clearable>
          <el-option
            v-for="item in customerList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span class="title">商品名称：</span>
        <el-input
          class="top-input"
          v-model="name"
          placeholder="请输入商品名称"
          clearable
        ></el-input>
        <span class="title">商品条码：</span>
        <el-input
          class="top-input"
          v-model="barCode"
          placeholder="请输入商品条码"
          clearable
        ></el-input>
      </div>
      <div class="search-left">
        <span class="title">商品编码：</span>
        <el-input
          class="top-input"
          v-model="code"
          placeholder="请输入商品编码"
          clearable
        ></el-input>
        <el-button icon="el-icon-search" class="btn-blue" @click="searchData"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" class="btn-gray" @click="reset"
          >重置</el-button
        >
      </div>
    </div>

    <!-- 商品信息列表 -->
    <div class="table">
      <div class="table-top">
        <div class="table-title">商品信息列表</div>
        <div class="export-file" @click="commodityImport">
          <span class="export-file-img"></span>
          <span>商品导入</span>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="openMod(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    <!-- 商品导入 -->
    <el-drawer
      title="商品导入"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer"
    >
      <div class="el-drawer__body">
        <el-form ref="form" :model="form">
          <el-form-item label="货主" prop="customerId">
            <el-select
              v-model="form.customerId"
              placeholder="请选择"
              class="white"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下载导入模板">
            <div class="download-tmp" @click="downloadTmp">
              商品导入模板.xlsx
              <img class="upload-bottom" src="~assets/images/upload/upload-bottom.png">
            </div>
          </el-form-item>
          <el-form-item label="上传附件">
            <el-input
              v-if="!uploadFileName"
              v-model="uploadFileName"
              placeholder="请上传文件"
              disabled
            >
              <template slot="suffix">
                <el-upload
                  :disabled="form.customerId ? false : true"
                  v-loading.fullscreen.lock="loading"
                  element-loading-text="文件上传中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  class="upload"
                  ref="upload"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="true"
                  :before-upload="uploadGoodsInfoExcel"
                >
                  <img
                    class="upload-img"
                    src="../../../../../assets/images/home/upload.png"
                    @click="clickUpload"
                  />
                </el-upload>
              </template>
            </el-input>
            <div v-else class="show-name">
              <span>{{ uploadFileName }}</span>
              <img
                @click="clearUploadFileName"
                src="../../../../../assets/images/close.png"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm">确定</el-button>
      </div>
    </el-drawer>

    <!-- 编辑 -->
    <el-drawer
      title="编辑"
      :visible.sync="modDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseModDrawer"
    >
      <div class="el-drawer__body">
        <el-form ref="modForm" :model="modForm">
          <el-form-item label="货主名称" prop="customerId">
            <el-select v-model="modForm.customerId" placeholder="请选择" class="white" clearable>
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品编码" prop="code">
            <el-input
              v-model="modForm.code"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="条码" prop="barCode">
            <el-input
              v-model="modForm.barCode"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input
              v-model="modForm.goodsName"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <p class="sub-title">商品规格</p>
          <div class="spec">
            <el-form-item label="规格编码" prop="specCode">
              <el-input
                v-model="modForm.specCode"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="规格值1" prop="specValue1">
              <el-input
                v-model="modForm.specValue1"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="规格值2" prop="specValue2">
              <el-input
                v-model="modForm.specValue2"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item label="有效天数（天）" prop="validDate">
            <el-input
              v-model="modForm.validDate"
              placeholder="请输入"
              clearable
              @input="inputNums(modForm.validDate, 'validDate')"
            ></el-input>
          </el-form-item>
          <el-form-item label="判次天数（天）" prop="judgeBadDay">
            <el-input
              v-model="modForm.judgeBadDay"
              placeholder="请输入"
              clearable
              @input="inputNums(modForm.judgeBadDay, 'judgeBadDay')"
            ></el-input>
          </el-form-item>
          <el-form-item label="箱规" prop="boxGauge">
            <el-input
              v-model="modForm.boxGauge"
              placeholder="请输入"
              clearable
              @input="boxGaugeInputNums(modForm.boxGauge, 'boxGauge')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseModDrawer"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="saveMod"
          >确定</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import GoodsInfo from "models/goods-info";
import customerMixins from "@/common/mixins/customer.js";
import { getPositiveInteger, downLoadFile } from "common/js/util";
export default {
  mixins: [customerMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        { label: "货主名称", prop: "customerName", width: "200" },
        { label: "商品编码", prop: "code", width: "120" },
        { label: "条码", prop: "barCode", width: "120" },
        { label: "商品名称", prop: "goodsName", width: "240" },
        { label: "商品规格", prop: "goodsSpecifications", width: "240" },
        { label: "有效天数", prop: "validDate", width: "" },
        { label: "判次天数", prop: "judgeBadDay", width: "" },
        { label: "箱规", prop: "boxGauge", width: "" },
      ],
      customerId: "",
      name: "",
      // 商品条码
      barCode: "",
      // 商品编辑码
      code: "",
      drawer: false,
      loading: false,
      form: {
        customerId: null,
      },
      formData: null,
      uploadFileName: "",
      // 是否开启编辑
      modDrawer: false,
      modForm: {
        id: null,
        customerId: null,
        code: '',
        barCode: '',
        goodsName: '',
        // 规格编码
        specCode: '',
        // 规格值1
        specValue1: '',
        // 规格值2
        specValue2: '',
        // 效期
        validDate: 0,
        // 判次天数
        judgeBadDay: 0,
        // 箱规
        boxGauge: 1,
      }
    };
  },

  created() {
    this.initGoodsInfoList();
    this.initCustomerList();
  },

  methods: {
    /**
     * @desc 商品信息列表
     */
    initGoodsInfoList() {
      let pageNo = this.currentPage;
      let customerId = this.customerId;
      let goodsName = this.name;
      let goodsCode = this.code;
      let goodsBarCode = this.barCode;
      GoodsInfo.getGoodsInfo(
        pageNo,
        customerId,
        goodsName,
        goodsBarCode,
        goodsCode
      ).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum;
          this.pageSize = res.result.pageSize;
          res.result.items.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.customerId = i.customerId;
            obj.customerName = i.customerName;
            obj.code = i.goodsCode;
            obj.barCode = i.barCode;
            obj.goodsName = i.goodsName;
            obj.specCode = i.specCode;
            obj.specValue1 = i.specValue1;
            obj.specValue2 = i.specValue2;
            obj.goodsSpecifications = `${i.specCode}${i.specValue1?`/${i.specValue1}`:''}${i.specValue2?`/${i.specValue2}`:''}`;
            obj.validDate = i.validDate;
            obj.judgeBadDay = i.judgeBadDay;
            obj.boxGauge = i.boxGauge;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initGoodsInfoList();
    },

    searchData() {
      this.currentPage = 1;
      this.initGoodsInfoList();
    },

    reset() {
      this.customerId = "";
      this.name = "";
      this.code = "";
      this.barCode = "";
    },

    commodityImport() {
      this.drawer = true;
    },

    handleCloseDrawer() {
      this.formData = null;
      this.drawer = false;
    },

    clickUpload() {
      if (!this.form.customerId) {
        this.$message.error("请选择货主");
      }
    },

    uploadGoodsInfoExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData;
      this.uploadFileName = file.name;
      return false;
    },

    /**
     * @desc 商品导入
     */
    confirm() {
      let formData = this.formData;
      formData.append("customerId", this.form.customerId);
      GoodsInfo.postUploadGoodsInfoExcel(formData)
        .then((res) => {
          if (res.success) {
            this.$message.success("导入成功");
            this.initGoodsInfoList();
            this.handleCloseDrawer();
          } else {
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning",
            }).then(() => {});
          }
        })
        .catch((res) => {
          this.$message.error("导入失败");
        });
    },

    /**
     * @desc 删除上传文件
     */
    clearUploadFileName() {
      this.uploadFileName = "";
      let formData = this.formData;
      if (formData.get("file")) {
        formData.delete("file");
      }
    },

    /**
     * @desc 开启编辑
     */
    openMod(row) {
      this.modForm.id = row.id;
      this.modForm.customerId = row.customerId;
      this.modForm.code = row.code;
      this.modForm.barCode = row.barCode;
      this.modForm.goodsName = row.goodsName;
      this.modForm.specCode = row.specCode;
      this.modForm.specValue1 = row.specValue1;
      this.modForm.specValue2 = row.specValue2;
      this.modForm.validDate = row.validDate;
      this.modForm.judgeBadDay = row.judgeBadDay;
      this.modForm.boxGauge = row.boxGauge;
      this.modDrawer = true
    },

    handleCloseModDrawer() {
      this.$refs['modForm'].resetFields();
      this.modDrawer = false
    },

    /**
     * @desc 编辑
     */
    saveMod() {
      let id = this.modForm.id;
      let customerId = this.modForm.customerId;
      let goodsCode = this.modForm.code
      let barCode = this.modForm.barCode
      let goodsName = this.modForm.goodsName
      let specCode = this.modForm.specCode
      let specValue1 = this.modForm.specValue1
      let specValue2 = this.modForm.specValue2
      let validDate = this.modForm.validDate
      let judgeBadDay = this.modForm.judgeBadDay
      let boxGauge = Number(this.modForm.boxGauge)
      let data = {
        id,
        customerId,
        goodsCode,
        barCode,
        goodsName,
        specCode,
        specValue1,
        specValue2,
        validDate,
        judgeBadDay,
        boxGauge
      }
      GoodsInfo.postModGoodsInfo(data).then((res) => {
        if (res.success) {
          this.handleCloseModDrawer()
          this.initGoodsInfoList()
        } else {
          this.$message.error(res.message);
        }
      });
    },

    
    /** 
     * @desc 限制数量为正整数
    */
    inputNums(val, type) {
      this.modForm[type] = getPositiveInteger(val);
    },
    
    /** 
     * @desc 限制数量为正整数(限制4位)
    */
    boxGaugeInputNums(val, type) {
      this.modForm[type] = this.getPositiveIntegerLimitToFourDigits(val);
    },

    /**
     * @desc 获取正整数(限制4位)
     */
    getPositiveIntegerLimitToFourDigits(num) {
      /**
       * ^[1-9]\d{0,3}$：以1到9开头，后面跟0到3位数字的正整数。
        |^0$：或者是单独的零。
      */
      let decimal = num.toString().match(/^[1-9]\d{0,3}|^0$/g)
        ? 
        num.toString().match(/^[1-9]\d{0,3}|^0$/g)[0]
        : "";
      return decimal;
    },

    /** 
     * @desc 下载商品导入模板
    */
    downloadTmp() {
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E5%AE%A2%E6%88%B7%E5%95%86%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      downLoadFile('商品导入模板',url)
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/style/layout/system/goods-info.scss";
</style>
